import NotFound from "@/components/AppRouter/NotFound";
import Container from "@/components/ContentContainer/Container";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import { useGetCompany, usePatchCompany } from "@/hooks/useAdmin";
import useTranslation from "@/hooks/useTranslation";
import { useUserSettings } from "@/hooks/useUserSettings";
import { Button, Flex, Form, Input, message, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AccessFormItem } from "@/pages/admin/companies/NewCompany";

export const COMPANY_TYPES = [
  { value: "production", label: "Production" },
  { value: "test", label: "Test" },
  { value: "trial", label: "Trial" },
];

export default function Company() {
  const { companyId: id } = useParams();
  const companyId = Number(id);

  const [form] = useForm();
  const { data: userSettings } = useUserSettings();
  const { data: company, isLoading: companyIsLoading } = useGetCompany({ companyId });
  const companyPatch = usePatchCompany();
  const navigate = useNavigate();
  const t = useTranslation();

  useEffect(() => {
    form.setFieldsValue({ ...company });
  }, [company]);

  if (userSettings && userSettings.role !== "root_admin") {
    return <NotFound />;
  }

  const onSubmit = () => {
    form.validateFields().then((values) => {
      companyPatch
        .mutateAsync({
          companyId,
          company: values,
        })
        .then((result) => {
          if (result.status === 200) {
            message.success("Company saved succesfully.");
            navigate("/admin/companies");
          }
        })
        .catch(() => {
          message.error(t.errors.general);
        });
    });
  };

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader
        title={company?.name}
        loading={companyIsLoading}
      />
      <Container>
        <Form
          form={form}
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 950,
          }}
          initialValues={company}
          autoComplete="off"
          layout={"vertical"}
        >
          <Form.Item
            required={true}
            label="Name"
            name="name"
          >
            <Input disabled={companyIsLoading} />
          </Form.Item>
          <Form.Item
            required={true}
            label="Type"
            name="type"
          >
            <Select options={COMPANY_TYPES} />
          </Form.Item>
          {AccessFormItem}
          <Button
            disabled={companyPatch.isLoading}
            loading={companyPatch.isLoading}
            onClick={onSubmit}
            type="primary"
          >
            Save
          </Button>
        </Form>
      </Container>
    </Flex>
  );
}
